import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import { DialogCustomizadoComponent } from 'src/app/components/genericos/dialog-customizado/dialog-customizado.component';
import { JwtService } from 'src/app/jwt.service';
import { ConverterCarrinhoManager } from 'src/app/managers/converter-carrinho.manager';
import { ItemManager } from 'src/app/managers/item-manager';
import { PedidoManager } from 'src/app/managers/pedido-manager';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { Carrinho } from 'src/app/persistences/carrinho';
import { Cliente } from 'src/app/persistences/cliente';
import { CdPgt } from 'src/app/persistences/condicao-pagamento';
import { FormaCondPgto } from 'src/app/persistences/forma-cond-pgto';
import { TipoEntrega } from 'src/app/persistences/tipo-entrega';
import { ConfigService } from 'src/app/services/config.service';
import { DownloadDocumentosService } from 'src/app/services/download-documentos.service';
import { FormaCondService } from 'src/app/services/forma-cond.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PesquisaService } from 'src/app/services/pesquisa.service';
import { CartSingletonService } from 'src/app/singletons/cart-singleton.service';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { CobrancaImediataPix } from './../../persistences/cobranca-imediata-pix';
import { PedidoFlex } from 'src/app/persistences/pedido-flex';

@Component({
  standalone: false,
  selector: 'app-carrinho-pagina',
templateUrl: './carrinho-pagina.component.html',
  styleUrls: ['./carrinho-pagina.component.css'],
})
export class CarrinhoPaginaComponent implements OnInit, OnDestroy {
  public carrinho: Carrinho = new Carrinho();
  private subscription: Subscription;
  public formasDePagamento: FormaCondPgto[];
  public tipoEntrega: Array<TipoEntrega>;  
  public tEntrega = false;
  public valorParcela: number;
  public listaCondicoes: CdPgt[];
  public condicao: CdPgt;
  public orcamento = false;
  public parcelaQuantidade: number;
  public parcela = false;
  public notaFiscal = false;
  public obs = '';
  public indiceTpEntrega: number;
  public gravandoPedido = false;

  public frase01 = 'Validando pedido. Aguarde...';
  public classHtml: string;
  public validandoItensDoCarrinho = true;
  public nomeFantasia: string;
  public temAcesso = parseInt(localStorage.getItem('tem_acesso_business')) == 0 ? false : true;

  public cdFormaPgtoSelecionado: number;  
  public cdCondPgtoSelecionado: number;  	

  public imprimePedido: string;

  constructor(
    private snackBarManager: SnackbarManager,
    public itemManager: ItemManager,
    private pedidoManager: PedidoManager,
    private pedidoService: PedidoService,
    private configService: ConfigService,
    public cartSingletonService: CartSingletonService,
    private router: Router,
    private converterCarrinhoManager: ConverterCarrinhoManager,
    private jwtService: JwtService,
    private clienteSingletonService: ClienteSingletonService,
    private formaCondService: FormaCondService,
    private dialog: MatDialog,
    private downloadDocumentos: DownloadDocumentosService,
    private pesquisaService: PesquisaService,
  ) {
    this.jwtService.checkLogin();
    if(!this.temAcesso){
      this.router.navigateByUrl('/minha-conta/meus-pedidos');
    }
    this.listaCondicoes = new Array<CdPgt>();
    this.imprimePedido = this.configService.getConfig().getImpressaoPedidoCarrinho;
  }

  ngOnDestroy() {
		this.subscription?.unsubscribe();
	}

  ngOnInit() {
    const cliente: Cliente = this.clienteSingletonService.getClienteEstatico();
    this.subscription = this.cartSingletonService.getCarrinhoObservable().subscribe(carrinho => {
			this.carrinho = carrinho;
		});
    if(this.carrinho.getCdCondPgto === undefined || this.carrinho.getCdFormaPgto === undefined){
      this.pedidoService.pedidoVendaPendenteBusiness(cliente.getCdCliente).subscribe(r => {
        this.cartSingletonService.atualizarDadosCabecalho(r.getCdFormaPgto, r.getCdCondPgto, r.getCdTpEntrega, r.getObservacoesInterna);
        this.formaCondService.getFormaCondPgto(cliente.getCdCliente).subscribe(response => {
          if(response.formas.length == 0){
            this.jwtService.logout();
            this.snackBarManager.openSnackBar("Não foi encontrado um perfil comercial para o usuário com forma e condição de pagamento ou segmento operacional do pedido.","Ok", 3000);
            return
          }
          const formasAgrupadas: FormaCondPgto[] = [];
          response.formas.forEach( forma => {
              const cdForma = forma.cdFormaPgto;
              if(!formasAgrupadas.some(item => item.cdFormaPgto === cdForma)){
                  formasAgrupadas.push(forma)
              } else{
                  forma.condicoes.forEach(cond => {
                      const formaAtual = formasAgrupadas.find(forma => forma.cdFormaPgto === cdForma)
                      if(!formaAtual.condicoes.some(item => item.cdCondPgto === cond.cdCondPgto)){
                          formasAgrupadas.forEach(forma => {
                              if(forma.cdFormaPgto === cdForma){
                                  forma.condicoes.push(cond);
                              }
                          })
                      }
                  })
              }
          })
          const formasResponse = formasAgrupadas.filter(forma => forma.cdFormaPgto === this.carrinho.getCdFormaPgto);
          let temForma = false;
          for(const f of formasResponse){
            const forma = f.condicoes;
            for(const condicao of forma){
              if(condicao.cdCondPgto === this.carrinho.getCdFormaPgto){
                temForma = true;
              }
            }
          }
          if(!temForma){
            this.cartSingletonService.setFormaECondicaoDePagamento(formasAgrupadas);                                        
            this.clienteSingletonService.atualizaFormaCodPadrao(formasAgrupadas);
          }
          this.formasDePagamento = this.carrinho.getFormaCondPgto.sort((form1, form2) =>
            form1.nmFormaPgto > form2.nmFormaPgto ? 1 : -1
          );
          this.listaCondicoes = new Array<CdPgt>();
          const formas = [];
          this.formasDePagamento.forEach((r) => { 
            if(r.cdFormaPgto === this.carrinho.getCdFormaPgto){
              formas.push(r);
            }
          });
          formas.forEach((r) => {
            r.condicoes.forEach((res) => {
              if(res.cdCondPgto === this.carrinho.getCdCondPgto){
                this.cartSingletonService.atualizarNrParcelas(res.nrParcelas);
              }
            })
          });
          this.cdFormaPgtoSelecionado = this.carrinho.getCdFormaPgto;
          this.cdCondPgtoSelecionado = this.carrinho.getCdCondPgto;
          this.obs = this.carrinho.getObs;
          this.condPadrao();           
          this.setCondPgtoSelecionada(this.cdCondPgtoSelecionado);
          this.calcularParcela(this.cdCondPgtoSelecionado);
          this.getTiposDeEntrega();
          this.getValorFretePadrao();
          this.nomeFantasia = this.ajustarNomeParaInicialEmMaiusculo(this.clienteSingletonService.getClienteEstatico().getClienteFilial.getNmFantasia);
          this.validarItensDoCarrinho().then((resolve) => {
            this.validandoItensDoCarrinho = resolve;
          });
        },
        (error) => {
          this.gravandoPedido = false;
          this.jwtService.validarAcessToken(error);
          this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar as formas de pagamento.', "Ok", 3000);
        })
      },
      (error) => {
        this.gravandoPedido = false;
        this.jwtService.validarAcessToken(error);
        this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar as formas de pagamento.', "Ok", 3000);
      });
    } else{
      this.formaCondService.getFormaCondPgto(cliente.getCdCliente)
      .subscribe((response) => {
        if(response.formas.length == 0){
          this.jwtService.logout();
          this.snackBarManager.openSnackBar("Não foi encontrado um perfil comercial para o usuário com forma e condição de pagamento ou segmento operacional do pedido.","Ok", 3000);
          return
        }
        const formasAgrupadas: FormaCondPgto[] = [];
        response.formas.forEach( forma => {
            const cdForma = forma.cdFormaPgto;
            if(!formasAgrupadas.some(item => item.cdFormaPgto === cdForma)){
                formasAgrupadas.push(forma)
            } else{
                forma.condicoes.forEach(cond => {
                    const formaAtual = formasAgrupadas.find(forma => forma.cdFormaPgto === cdForma)
                    if(!formaAtual.condicoes.some(item => item.cdCondPgto === cond.cdCondPgto)){
                        formasAgrupadas.forEach(forma => {
                            if(forma.cdFormaPgto === cdForma){
                                forma.condicoes.push(cond);
                            }
                        })
                    }
                })
            }
        })
        const formasResponse = formasAgrupadas.filter(forma => forma.cdFormaPgto === this.carrinho.getCdFormaPgto);
        let temForma = false;
        for(const f of formasResponse){
          const forma = f.condicoes;
          for(const condicao of forma){
            if(condicao.cdCondPgto === this.carrinho.getCdCondPgto){
              temForma = true;
            }
          }
        }
        if(!temForma){
          this.cartSingletonService.setFormaECondicaoDePagamento(formasAgrupadas);                                               
          this.clienteSingletonService.atualizaFormaCodPadrao(formasAgrupadas);

        }
        this.formasDePagamento = this.carrinho.getFormaCondPgto.sort((form1, form2) =>
          form1.nmFormaPgto > form2.nmFormaPgto ? 1 : -1
        );
        this.listaCondicoes = new Array<CdPgt>();
        const formas = [];
        this.formasDePagamento.forEach((r) => { 
          if(r.cdFormaPgto === this.carrinho.getCdFormaPgto){
            formas.push(r);
          }
        });
        formas.forEach((r) => {
          r.condicoes.forEach((res) => {
            if(res.cdCondPgto === this.carrinho.getCdCondPgto){              
              this.cartSingletonService.atualizarNrParcelas(res.nrParcelas);
            }
          })
        })
        this.cdFormaPgtoSelecionado = this.carrinho.getCdFormaPgto;
        this.cdCondPgtoSelecionado = this.carrinho.getCdCondPgto;
        this.obs = this.carrinho.getObs;
        this.condPadrao();           
        this.setCondPgtoSelecionada(this.cdCondPgtoSelecionado);
        this.calcularParcela(this.cdCondPgtoSelecionado);
        this.getTiposDeEntrega();
        this.getValorFretePadrao();
        this.nomeFantasia = this.ajustarNomeParaInicialEmMaiusculo(this.clienteSingletonService.getClienteEstatico().getClienteFilial.getNmFantasia);
        this.validarItensDoCarrinho().then((resolve) => {
          this.validandoItensDoCarrinho = resolve;
        });
      },
      (error) => {
        this.gravandoPedido = false;
        this.jwtService.validarAcessToken(error);
        this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar as formas de pagamento.', "Ok", 3000);
      })
    }
  }

  calcularParcela(cdCondPgto) {
    this.setCondAtual(cdCondPgto);
    this.parcelaQuantidade = this.listaCondicoes.find(condPgto => 
      condPgto.cdCondPgto === parseInt(cdCondPgto)).nrParcelas;
      this.valorParcela = this.carrinho.getTotal / this.parcelaQuantidade; 
  }

  limparArray(array: Array<CdPgt>) {
    array.splice(0, array.length);
  }
  
  getTiposDeEntrega() {
    this.tipoEntrega = [];
    this.pedidoService.getTipoEntrega().subscribe(
      (res) => {
        this.pedidoService.getTiposEntregaCarrinho().subscribe((response) => {
          if(response.valor !== ""){
            const tiposEntregaCarrinho = response.valor.trim().split(",").map(Number);
            tiposEntregaCarrinho.forEach((tipoCarrinho) => {
              const tipo = res.find((tipo) => tipoCarrinho === tipo.cdTipoEntrega);
              if (tipo) {
                this.tipoEntrega.push(tipo);
              }
            });
          }else{
            this.tipoEntrega = res;
          }
          const tipoIgual = this.tipoEntrega.find((tipo)=> {return tipo.cdTipoEntrega == this.carrinho.getCdTpEntrega} ) 
          if(tipoIgual){
            this.indiceTpEntrega =  this.carrinho.getCdTpEntrega
          }else{
            this.indiceTpEntrega =  0;
          }
        });
      },
      (error) => {
        console.log(error);
        this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar os tipos de entrega.', "Ok", 3000);
      }
    );
    this.tEntrega = true;
  }

  getValorFretePadrao(){
    const valorFrete = this.clienteSingletonService.getClienteEstatico().getVlFretePadrao;
    this.cartSingletonService.atualizarFrete(!this.configService.getConfig().getUsaValorDeFretePadraoDoCliente ? 0 :
      valorFrete !== null ?
      valorFrete : 0);
  }  

  async continuarComprando() {
    if(!this.validaCamposCabecalho())
      return;
    this.cartSingletonService.atualizarDadosCabecalho(this.cdFormaPgtoSelecionado, this.cdCondPgtoSelecionado, this.indiceTpEntrega, this.obs);

    const itens = this.cartSingletonService.getCarrinhoEstatico().getItensCarrinho;
    const ids = itens.map(item => item.itemDetalhes.idItem);

    itens.forEach(item => {
      item.itemPedido.visualizouPrecoAntigo = false;
      this.itemManager.calcularVlPrecoTabelaAntigo(item);
    });

    const itensFrescos = await firstValueFrom(this.pesquisaService.carregaItensByIds(ids));

    for (const item of itens) {
      const itemFresco = itensFrescos.find(i => i.idItem === item.itemDetalhes.idItem);
      if (itemFresco) {
        item.itemDetalhes.outrosPrecos = itemFresco.outrosPrecos ?? item.itemDetalhes.outrosPrecos;
        item.itemDetalhes.tabelaPrecoView = itemFresco.tabelaPrecoView ?? item.itemDetalhes.tabelaPrecoView;
      }
      await this.itemManager.getValor(item);
    }

    this.cartSingletonService.sincronizarItensCarrinho();

    this.pedidoManager
      .atualizarPedidoEdicao()
      .then(() => (
        this.router.navigateByUrl('/')
      ))
      .catch((error: HttpErrorResponse) => {
        this.snackBarManager.openSnackBarErro(error, 'Não foi possível atualizar o pedido.', 'Ok', 3000);
      });
  }

  validaCamposCabecalho(): boolean{    
    if (this.cdFormaPgtoSelecionado == undefined || this.cdFormaPgtoSelecionado == null || this.cdFormaPgtoSelecionado == 0) {
      this.snackBarManager.openSnackBar(
        'Informe uma Forma de Pagamento, por favor',
        'Ok',
        3000
      );
      return false;
    }
    if (this.cdCondPgtoSelecionado == undefined || this.cdCondPgtoSelecionado == null|| this.cdCondPgtoSelecionado == 0) {
      this.snackBarManager.openSnackBar(
        'Informe uma Condição de Pagamento, por favor',
        'Ok',
        3000
      );
      return false;
    }
    if (this.indiceTpEntrega == undefined || this.indiceTpEntrega == null|| this.indiceTpEntrega == 0) {
      this.snackBarManager.openSnackBar(
        'Informe um Tipo de Entrega, por favor',
        'Ok',
        3000
      );
      return false;
    }
    return true;    
  }

  async finalizar() {
    if(!this.validaCamposCabecalho())
      return;
    this.gravandoPedido = true;
    this.cartSingletonService.atualizarDadosCabecalho(this.cdFormaPgtoSelecionado, this.cdCondPgtoSelecionado, this.indiceTpEntrega, this.obs);
    await this.pedidoManager.promiseResolverDadosTransporte(this.indiceTpEntrega);
    const cliente: Cliente = this.clienteSingletonService.getClienteEstatico();
    const itemForaDeEstoque = this.cartSingletonService.getCarrinhoEstatico().getItensCarrinho.find(
      (item) => item.itemPedido.quantidade > item.itemPedido.quantidadeEstoque
    );
    const itensCarrinho = this.cartSingletonService.getCarrinhoEstatico().getItensCarrinho;
    // Chamado #74296: item cuja unidade gravada deixou de estar liberada (Ação 159) segue no carrinho,
    // mas bloqueia a finalização até o usuário removê-lo. Tem mensagem própria, então sai da lista de "sem preço".
    const itensUnidadeIndisponivel = itensCarrinho.filter(
      (item) => this.itemManager.isUnidadeVendaIndisponivel(item)
    );
    const itensSemPreco = itensCarrinho.filter(
      (item) => item.itemDetalhes.outrosPrecos.length === 0 && !itensUnidadeIndisponivel.includes(item)
    );

    if (itensUnidadeIndisponivel.length > 0 || itensSemPreco.length > 0) {
      const motivos: string[] = [];
      if (itensUnidadeIndisponivel.length > 0) {
        const ids = itensUnidadeIndisponivel.map(item => item.itemDetalhes.cdItem).join(', ');
        motivos.push(`item(s) com unidade de venda indisponível: ${ids}`);
      }
      if (itensSemPreco.length > 0) {
        const ids = itensSemPreco.map(item => item.itemDetalhes.cdItem).join(', ');
        motivos.push(`item(s) sem tabela de preço: ${ids}`);
      }
      const orientacao = itensUnidadeIndisponivel.length > 0 ? '. Remova-os do pedido para continuar.' : '';
      this.snackBarManager.openSnackBar(`Não foi possível finalizar o pedido, ${motivos.join('; ')}${orientacao}`, 'Ok', 5000);
      this.abortarFinalizacao();
      return;
    }

    if (itemForaDeEstoque) {
      const confirmacao = await this.openConfirmationDialog(
        'Item(s) no pedido com estoque indisponível no momento! Deseja enviar o pedido dessa forma?'
      );
  
      if (!confirmacao) {
        this.abortarFinalizacao();
        return;
      }
    }
    const pedido = this.converterCarrinhoManager.converterCarrinhoParaPedido(
      this.orcamento,
      this.obs,
      this.notaFiscal
    );
    setTimeout(() => {      
      this.formaCondService.getFormaCondPgto(cliente.getCdCliente).subscribe((response) => {
        if(response.formas.length == 0){
          this.jwtService.logout();
          this.snackBarManager.openSnackBar("Não foi encontrado um perfil comercial para o usuário com forma e condição de pagamento ou segmento operacional do pedido.","Ok", 3000);
          return
        }
        const formasAgrupadas: FormaCondPgto[] = [];
        response.formas.forEach( forma => {
            const cdForma = forma.cdFormaPgto;
            if(!formasAgrupadas.some(item => item.cdFormaPgto === cdForma)){
                formasAgrupadas.push(forma)
            } else{
                forma.condicoes.forEach(cond => {
                    const formaAtual = formasAgrupadas.find(forma => forma.cdFormaPgto === cdForma)
                    if(!formaAtual.condicoes.some(item => item.cdCondPgto === cond.cdCondPgto)){
                        formasAgrupadas.forEach(forma => {
                            if(forma.cdFormaPgto === cdForma){
                                forma.condicoes.push(cond);
                            }
                        })
                    }
                })
            }
        })
        const formasResponse = formasAgrupadas.filter(forma => forma.cdFormaPgto === this.carrinho.getCdFormaPgto);
        let temForma = false;
        for(const f of formasResponse){
          const forma = f.condicoes;
          for(const condicao of forma){
            if(condicao.cdCondPgto === this.carrinho.getCdCondPgto){
              temForma = true;
            }
          }
        }
        if(!temForma){
          this.cartSingletonService.setFormaECondicaoDePagamento(formasAgrupadas);                                        
          this.clienteSingletonService.atualizaFormaCodPadrao(formasAgrupadas);                           
          this.formasDePagamento = this.carrinho.getFormaCondPgto.sort((form1, form2) =>
            form1.nmFormaPgto > form2.nmFormaPgto ? 1 : -1
          );
          this.cdCondPgtoSelecionado = this.carrinho.getCdCondPgto;
          this.cdFormaPgtoSelecionado = this.carrinho.getCdFormaPgto;
          this.indiceTpEntrega = this.carrinho.getCdTpEntrega;
          this.listarFormasDePagamento(this.cdFormaPgtoSelecionado);
          this.abortarFinalizacao();
          this.snackBarManager.openSnackBar("O usuário não possui a forma e condição de pagamento, por favor escolha outra forma e condição","Ok", 3000);
          return
        }
        const formaECondCarrinho = this.cartSingletonService.getFormaECondicaoDePagamento();
        if(formaECondCarrinho.pixAntecipado && formaECondCarrinho.chavePix.trim() != ""){
          const cdCaixaPix =  this.configService.getConfig().getCdCaixaPix;
          const cobrancaImediataPix: CobrancaImediataPix = {
            cdCliente: pedido.cdCliente,
            cdCaixa: Number(cdCaixaPix),
            cdFilial: pedido.cdFilial,
            cdFormaPgto: formaECondCarrinho.cdFormaPgto,
            chave: formaECondCarrinho.chavePix,
            idPedido: pedido.idGeral,
            valor: pedido.vlTotal,
            obs: "Pagamento Pix - " + pedido.idGeral.toString()
          }
          
          
          this.pedidoService.cobrancaImediataPix(cobrancaImediataPix).subscribe(res => {
            localStorage.setItem("pixCopiaECola", res.pixCopiaECola);
            localStorage.setItem("pixId", res.id);
            pedido.cdSituacao = 8;
            this.pedidoService.gravarPedido(pedido).subscribe(
            (res) => {
              if (res['success'] == true) {
                this.snackBarManager.openSnackBar(
                  'O pedido ' + res['nrPedido'] + ' foi salvo.',
                  'Ok',
                  2000
                );    
              const cliente  = this.clienteSingletonService.getClienteEstatico();  
              this.cartSingletonService.novoCarrinho(cliente.getCdFormaPadrao, cliente.getCdCondPadrao, cliente.getCdTipoEntrega,  '');
              this.formaCondService.getFormaCondPgto(cliente.getCdCliente)
              .subscribe((response) => {
                if(response.formas.length == 0){
                  this.jwtService.logout();
                  this.snackBarManager.openSnackBar("O usuário não possui perfil comercial com forma e condição de pagamento","Ok", 5000);
                  return
                }
                const formasAgrupadas: FormaCondPgto[] = [];
                response.formas.forEach( forma => {
                    const cdForma = forma.cdFormaPgto;
                    if(!formasAgrupadas.some(item => item.cdFormaPgto === cdForma)){
                        formasAgrupadas.push(forma)
                    } else{
                        forma.condicoes.forEach(cond => {
                            const formaAtual = formasAgrupadas.find(forma => forma.cdFormaPgto === cdForma)
                            if(!formaAtual.condicoes.some(item => item.cdCondPgto === cond.cdCondPgto)){
                                formasAgrupadas.forEach(forma => {
                                    if(forma.cdFormaPgto === cdForma){
                                        forma.condicoes.push(cond);
                                    }
                                })
                            }
                        })
                    }
                })
                this.cartSingletonService.setFormaECondicaoDePagamento(formasAgrupadas);                                        
                this.clienteSingletonService.atualizaFormaCodPadrao(formasAgrupadas);                       
                this.pedidoManager.promiseNovoPedidoVenda().then(
                  () => this.router.navigateByUrl('/pagamento-pix'))
                .catch((error) => {
                  this.gravandoPedido = false;
                  this.snackBarManager.openSnackBarErro(error, 'Não foi possível iniciar um novo pedido.', 'Ok', 3000);
                });
              },
              (error) => {
                this.gravandoPedido = false;
                this.jwtService.validarAcessToken(error);
                this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar as formas de pagamento.', "Ok", 3000);
              })
              
            } else {
              this.abortarFinalizacao();
              this.snackBarManager.openSnackBar(
                'Erro ao finalizar pedido. ' + res['mensagem'],
                'Ok',
                2000
              );    
            const cliente  = this.clienteSingletonService.getClienteEstatico();  
            this.cartSingletonService.novoCarrinho(cliente.getCdFormaPadrao, cliente.getCdCondPadrao, cliente.getCdTipoEntrega,  '');
            this.formaCondService.getFormaCondPgto(cliente.getCdCliente)
            .subscribe((response) => {
              if(response.formas.length == 0){
                this.jwtService.logout();
                this.snackBarManager.openSnackBar("Não foi encontrado um perfil comercial para o usuário com forma e condição de pagamento ou segmento operacional do pedido.","Ok", 5000);
                return
              }
              const formasAgrupadas: FormaCondPgto[] = [];
              response.formas.forEach( forma => {
                  const cdForma = forma.cdFormaPgto;
                  if(!formasAgrupadas.some(item => item.cdFormaPgto === cdForma)){
                      formasAgrupadas.push(forma)
                  } else{
                      forma.condicoes.forEach(cond => {
                          const formaAtual = formasAgrupadas.find(forma => forma.cdFormaPgto === cdForma)
                          if(!formaAtual.condicoes.some(item => item.cdCondPgto === cond.cdCondPgto)){
                              formasAgrupadas.forEach(forma => {
                                  if(forma.cdFormaPgto === cdForma){
                                      forma.condicoes.push(cond);
                                  }
                              })
                          }
                      })
                  }
              })
              this.cartSingletonService.setFormaECondicaoDePagamento(formasAgrupadas);                                        
              this.clienteSingletonService.atualizaFormaCodPadrao(formasAgrupadas);                       
              this.pedidoManager.promiseNovoPedidoVenda().then(
                () => this.router.navigateByUrl('/home'))
              .catch((error) => {
                this.gravandoPedido = false;
                this.snackBarManager.openSnackBarErro(error, 'Não foi possível iniciar um novo pedido.', 'Ok', 3000);
              });
            },
            (error) => {
              this.gravandoPedido = false;
              this.jwtService.validarAcessToken(error);
              this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar as formas de pagamento.', "Ok", 3000);
            })
          }

          },
          (error) => {
            this.abortarFinalizacao();
            this.jwtService.validarAcessToken(error);
            this.snackBarManager.openSnackBarErro(error, 'Não foi possível finalizar o pedido.', "Ok", 3000);
          }
        );
          },(error) => {
                this.abortarFinalizacao();
                this.jwtService.validarAcessToken(error);
                this.snackBarManager.openSnackBarErro(error, 'Não foi possível gerar a cobrança Pix.', "Ok", 3000);
              })
          return;
        } else{
          this.pedidoService.gravarPedido(pedido).subscribe(
            (res) => {
              if (res['success'] == true) {
                this.snackBarManager.openSnackBar(
                  'O pedido ' + res['nrPedido'] + ' foi salvo.',
                  'Ok',
                  2000
                );    
              const cliente  = this.clienteSingletonService.getClienteEstatico();  
              this.cartSingletonService.novoCarrinho(cliente.getCdFormaPadrao, cliente.getCdCondPadrao, cliente.getCdTipoEntrega,  '');
              this.formaCondService.getFormaCondPgto(cliente.getCdCliente)
              .subscribe((response) => {
                if(response.formas.length == 0){
                  this.jwtService.logout();
                  this.snackBarManager.openSnackBar("O usuário não possui perfil comercial com forma e condição de pagamento","Ok", 5000);
                  return
                }
                const formasAgrupadas: FormaCondPgto[] = [];
                response.formas.forEach( forma => {
                    const cdForma = forma.cdFormaPgto;
                    if(!formasAgrupadas.some(item => item.cdFormaPgto === cdForma)){
                        formasAgrupadas.push(forma)
                    } else{
                        forma.condicoes.forEach(cond => {
                            const formaAtual = formasAgrupadas.find(forma => forma.cdFormaPgto === cdForma)
                            if(!formaAtual.condicoes.some(item => item.cdCondPgto === cond.cdCondPgto)){
                                formasAgrupadas.forEach(forma => {
                                    if(forma.cdFormaPgto === cdForma){
                                        forma.condicoes.push(cond);
                                    }
                                })
                            }
                        })
                    }
                })
                this.cartSingletonService.setFormaECondicaoDePagamento(formasAgrupadas);                                        
                this.clienteSingletonService.atualizaFormaCodPadrao(formasAgrupadas);                       
                this.pedidoManager.promiseNovoPedidoVenda().then(
                  () => this.router.navigateByUrl('/home'))
                .catch((error) => {
                  this.gravandoPedido = false;
                  this.snackBarManager.openSnackBarErro(error, 'Não foi possível iniciar um novo pedido.', 'Ok', 3000);
                });
              },
              (error) => {
                this.gravandoPedido = false;
                this.jwtService.validarAcessToken(error);
                this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar as formas de pagamento.', "Ok", 3000);
              })
              
            } else {
              this.abortarFinalizacao();
              this.snackBarManager.openSnackBar(
                'Erro ao finalizar pedido. ' + res['mensagem'],
                'Ok',
                2000
              );
            }
            this.router.navigateByUrl('/home');
            this.gravandoPedido = false;
          },
          (error) => {
            this.abortarFinalizacao();
            this.jwtService.validarAcessToken(error);
            this.snackBarManager.openSnackBarErro(error, 'Não foi possível finalizar o pedido.', "Ok", 3000);
          }
        );
      }
      },
      (error) => {
        this.abortarFinalizacao();
        this.jwtService.validarAcessToken(error);
        this.snackBarManager.openSnackBarErro(error, 'Não foi possível carregar as formas de pagamento.', "Ok", 3000);
      })
    }, 2500);
  }

  listarFormasDePagamento(value) {  
    this.limparArray(this.listaCondicoes);
    this.formasDePagamento.forEach((formas) => {
      if (value == formas.cdFormaPgto) {
        formas.condicoes.forEach((condPgto) => {
          this.condicao = new CdPgt();
          this.condicao.cdFormaPgto = formas.cdFormaPgto;
          this.condicao.cdCondPgto = condPgto.cdCondPgto;
          this.condicao.nmCondPgto = condPgto.nmCondPgto;
          this.condicao.hierarquia = condPgto.hierarquia;
          this.condicao.diaDoMes = condPgto.diaDoMes.toString();
          this.condicao.diaSemana = condPgto.diaSemana.toString();
          this.condicao.modalidade = condPgto.modalidade;
          this.condicao.nrParcelas = condPgto.nrParcelas;
          this.condicao.vlMinimoParcela = condPgto.vlMinimoParcela.toString();
          this.condicao.prazoInicial = condPgto.prazoInicial;
          this.condicao.nrDiasPrazoMaximo = condPgto.nrDiasPrazoMaximo;
          this.parcela = formas.classificacao.toUpperCase() == 'R';
          if (this.parcela)
            this.parcelaQuantidade = Number.parseInt(
              formas.condicoes[0].nmCondPgto.replace(/\D/g, '')
            );
          this.listaCondicoes.push(this.condicao);
        });
        this.setFormaPgtoSelecionada(Number.parseInt(value));
        this.setCondAtual(this.listaCondicoes[0].cdCondPgto);      
      }
    });    
    this.calcularParcela(this.cdCondPgtoSelecionado);    
  }

  condPadrao() {
    this.listaCondicoes = new Array<CdPgt>();
    this.formasDePagamento.forEach((formas) => {
      const possuiForma = this.carrinho.getCdFormaPgto == formas.cdFormaPgto;
      if (possuiForma) {
        formas.condicoes.forEach((condPgto) => {
          this.condicao = new CdPgt();
          this.condicao.cdFormaPgto = formas.cdFormaPgto;
          this.condicao.cdCondPgto = condPgto.cdCondPgto;
          this.condicao.nmCondPgto = condPgto.nmCondPgto;
          this.condicao.hierarquia = condPgto.hierarquia;
          this.condicao.diaDoMes = condPgto.diaDoMes.toString();
          this.condicao.diaSemana = condPgto.diaSemana.toString();
          this.condicao.modalidade = condPgto.modalidade;
          this.condicao.nrParcelas = condPgto.nrParcelas;
          this.condicao.vlMinimoParcela = condPgto.vlMinimoParcela.toString();
          this.condicao.prazoInicial = condPgto.prazoInicial;
          this.condicao.nrDiasPrazoMaximo = condPgto.nrDiasPrazoMaximo;
          this.listaCondicoes.push(this.condicao);
        });
      }
    });
  }

  setTpEntrega(value) {
    this.indiceTpEntrega = value;
    /*
     * Tp. frete e transportador do carrinho são derivados do tipo de entrega. Trocar o
     * tipo invalida o que já estava resolvido — o reset é síncrono de propósito, para
     * não criar corrida com o clique em Finalizar; os valores definitivos são buscados
     * em promiseResolverDadosTransporte, no envio do pedido.
     */
    this.cartSingletonService.limparDadosTransporte();
  }

  /*
   * Interrompe a finalização: libera os controles e invalida os dados de transporte
   * resolvidos na tentativa, que não devem sobreviver a um pedido que não foi gravado.
   * NÃO deve ser usado nos caminhos posteriores ao sucesso da gravação — lá o
   * novoCarrinho já zerou o carrinho inteiro.
   */
  private abortarFinalizacao(): void {
    this.cartSingletonService.limparDadosTransporte();
    this.gravandoPedido = false;
  }

  setFormaPgtoSelecionada(cdFormaPgto) {
    this.cdFormaPgtoSelecionado = parseInt(cdFormaPgto);
  }  

  setCondPgtoSelecionada(cdCondPgto) {
    this.cdCondPgtoSelecionado = parseInt(cdCondPgto);
    this.parcela = this.formasDePagamento.find(formaPgto =>       
      formaPgto.cdFormaPgto === this.cdFormaPgtoSelecionado
      ).classificacao === 'R';
    this.calcularParcela(this.cdCondPgtoSelecionado); 
  }    

  getFormaPadrao(): number {    
    const formaPagto = this.cartSingletonService.getFormaECondicaoDePagamento();
    return formaPagto.cdFormaPgto;
  }

  setCondAtual(value) {
    this.cdCondPgtoSelecionado = value;
  }  

  getCondPgtoSelecionada(): number {    
    return  this.cdCondPgtoSelecionado;
  }   

  validarItensDoCarrinho(): Promise<boolean> {
    const itensComFalhaDeRevalidacao: (string | number)[] = [];
    const validacoes = this.carrinho.getItensCarrinho.map((item) =>
      this.itemManager.getValor(item).catch((err) => {
        console.error('Erro ao revalidar preço/desconto do item do carrinho', item.itemDetalhes?.idItem, err);
        this.jwtService.validarAcessToken(err);
        itensComFalhaDeRevalidacao.push(item.itemDetalhes?.idItem);
      })
    );
    return Promise.all(validacoes).then(() => {
      if (itensComFalhaDeRevalidacao.length > 0) {
        this.snackBarManager.openSnackBar(
          'Não foi possível atualizar o preço de um ou mais itens do carrinho. Os valores exibidos podem estar desatualizados.',
          'Ok',
          5000
        );
      }
      return false;
    });
  }

  ajustarNomeParaInicialEmMaiusculo(string: string){
    const nome = string.toLowerCase().split(' ');
    for(let i = 0; i< nome.length; i++){
      const palavra = nome[i];
      const nomeCorrigido = palavra.charAt(0).toUpperCase() + palavra.slice(1);
      nome[i] = nomeCorrigido;
    }
    return nome.join(' ');
  }

  async openConfirmationDialog(mensagem: string): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(DialogCustomizadoComponent, {
        width: '300px',
        height: '200px',
        panelClass: 'custom-dialog',
        data: { labelMensagem: mensagem, labelConfirmacao: 'Sim', labelNegacao: 'Não' }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        resolve(result);
      });
    });
  }

  imprimirPedidoCarrinho(){
    const idPedidoVenda = this.cartSingletonService.getPedidoVenda().getIdGeral;
    const filial = this.clienteSingletonService.getClienteEstatico().getClienteFilial.getCdFilial;
    this.downloadDocumentos.getRelatorio(filial, idPedidoVenda).subscribe(res =>{
      const link = this.configService.getEndereco() + res['relatorio'];
      window.open(link);
    },
    (error)=> {
      this.snackBarManager.openSnackBarErro(error, 'Não foi possível gerar o relatório do pedido.', "Ok", 3000);
    })
    return
  }
}
